import React from 'react';
import PropTypes from 'prop-types';

import cn from 'utils/classnames';

import styles from './ProgressBar.module.scss';

function ProgressBar(props) {
  const { className, title, value } = props;

  return (
    <div className={cn(styles.Component, className)}>
      <p className={styles.Title}>{title}</p>

      <div className={styles.ProgressWrap}>
        <span className={styles.Progress}>
          <span
            style={{
              '--progress-value': `${value * 10}%`,
            }}
            className={styles.Value}
          />
        </span>

        <span>
          {value}
          /10
        </span>
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ProgressBar.defaultProps = {
  value: 0,
  className: '',
};

export default React.memo(ProgressBar);
